"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Marker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var timeUtils_1 = require("../utils/timeUtils");
/**
 * A `Marker` is a component draws a vertical line.
 *
 * @extends React.Component<Marker.propTypes>
 */
var Marker = /** @class */ (function (_super) {
    __extends(Marker, _super);
    function Marker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Marker.prototype.shouldComponentUpdate = function (nextProps) {
        if (nextProps.shouldUpdate ||
            this.props.height !== nextProps.height ||
            this.props.top !== nextProps.top ||
            !(0, timeUtils_1.convertDateToMoment)(this.props.date).isSame((0, timeUtils_1.convertDateToMoment)(nextProps.date).valueOf())) {
            return true;
        }
        return false;
    };
    /**
     * @returns { object } style
     */
    Marker.prototype.getStyle = function () {
        var left = this.props.calculateHorizontalPosition(this.props.date).left;
        return __assign(__assign({}, this.props.style), { top: this.props.top, height: this.props.height, left: left, display: left ? 'block' : 'none' });
    };
    /**
     * @returns { string } className
     */
    Marker.prototype.getClassName = function () {
        return "rct9k-marker ".concat(this.props.className);
    };
    Marker.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)("hr", { className: this.getClassName(), style: this.getStyle() });
    };
    Marker.propTypes = {
        /**
         * The position of the marker, as date (numeric/millis or moment object, cf. `Timeline.props.useMoment`).
         *
         * @type { object | number }
         */
        date: prop_types_1.default.oneOfType([prop_types_1.default.object, prop_types_1.default.number]).isRequired,
        /**
         * Class name used to render the marker.
         *
         * @type { string }
         */
        className: prop_types_1.default.string,
        /**
         * Style used to render the marker.
         *
         * @type { object }
         */
        style: prop_types_1.default.object,
        /**
         * Internal (passed by parent). The height of the marker.
         *
         * @type { number }
         */
        height: prop_types_1.default.number,
        /**
         * Internal (passed by parent). `Marker` uses absolute positioning, thus it needs the `top` property
         * to set the top edge if the element.
         *
         * @type { number }
         */
        top: prop_types_1.default.number,
        /**
         * Internal (passed by parent). This function allows the conversion of `date` (time) property to pixels.
         *
         * @type { Function }
         */
        calculateHorizontalPosition: prop_types_1.default.func.isRequired,
        /**
         * Internal (passed by parent). If true timeline will try to minimize re-renders (e.g: the displayed timeline interval changes).
         *
         * @type { boolean }
         */
        shouldUpdate: prop_types_1.default.bool
    };
    Marker.defaultProps = {
        className: '',
        style: undefined,
        height: undefined,
        top: undefined,
        calculateHorizontalPosition: function () { },
        shouldUpdate: false
    };
    return Marker;
}(react_1.default.Component));
exports.Marker = Marker;
//# sourceMappingURL=Marker.js.map